<script setup>
  const props = defineProps({
    error: { type: String },
    careerSite: { type: Object },
    linkColor: { type: String, default: '#58d9db' },
    // A CV deposit has no recruiter recipient.
    purpose: { type: String, default: 'd’un processus de recrutement' }
  })

  const config = useRuntimeConfig()
</script>

<template>
  <FormField id="policy" name="policy" :error="props.error" type="checkbox" required :uncheckedValue="false" :value="true">
    <template v-slot:label>
      <label class="text-sm" for="policy">
        Je certifie avoir lu et accepté que les données personnelles me concernant sont recueillies par
        <strong>{{ careerSite ? careerSite.employer.name : 'Profil Public' }}</strong
        >, responsable du traitement, dans le cadre {{ props.purpose }}. Conformément à la
        <NuxtLink
          class="font-bold underline duration-300"
          :style="{ textDecorationColor: linkColor }"
          :to="`${careerSite ? getCareerSiteUrl(careerSite) : config.public.baseUrl}/politique-de-donnees`"
          target="_blank"
          >Politique de données</NuxtLink
        >, je dispose d’un droit d’accès, d’effacement, de rectification et de portabilité de mes données ainsi qu’un droit d’opposition et de
        limitation au traitement de ces données.
      </label>
    </template>
  </FormField>
</template>
